import { S as SpringButton } from './SpringButton-56fcfdbc.js';
export { S as SpringButton } from './SpringButton-56fcfdbc.js';
import { S as SpringCard } from './SpringCard-84e57fcd.js';
export { S as SpringCard } from './SpringCard-84e57fcd.js';
import { S as SpringNav, a as SpringNavHamburger, b as SpringNavMobile, c as SpringNavDesktop } from './SpringNav-1d58e521.js';
export { S as SpringNav, c as SpringNavDesktop, a as SpringNavHamburger, b as SpringNavMobile } from './SpringNav-1d58e521.js';
import { S as SpringPopup } from './SpringPopup-f22f6c88.js';
export { S as SpringPopup } from './SpringPopup-f22f6c88.js';
import { c as colors$1 } from './theme-0fe3bd9d.js';
import './style-inject.es-1f59c1d0.js';
import './SpringBackdrop-9110741e.js';

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SpringButton: SpringButton,
  SpringCard: SpringCard,
  SpringNav: SpringNav,
  SpringNavHamburger: SpringNavHamburger,
  SpringPopup: SpringPopup,
  SpringNavMobile: SpringNavMobile,
  SpringNavDesktop: SpringNavDesktop
});

var screens$1 = {
  screens: {
    // => @media (max-width: 374px)
    'xxs-only': {
      max: '374px'
    },
    // => @media (min-width: 375px)
    xxs: '375px',
    // => @media (max-width: 599px)
    'xs-only': {
      max: '599px'
    },
    // => @media (min-width: 600px)
    sm: '600px',
    // => @media (min-width: 900px)
    md: '900px',
    // => @media (min-width: 1200px)
    lg: '1200px',
    // => @media (min-width: 1500px)
    xl: '1500px',
    // => @media print
    print: {
      raw: 'print'
    },
    portrait: {
      raw: '(orientation: portrait)'
    }
  }
};

var shadows = {
  boxShadow: {
    none: 'none',
    DEFAULT: '0 10px 20px 0px rgba(91,89,193,.11)',
    btn: '8px 8px 25px rgba(91,89,193,.16)',
    menu: '0 5px 20px 0 rgba(115,120,216,.15)',
    hover: '0 4px 20px rgba(115,120,216,.15)',
    footer: '0px 6px 47px rgba(23,57,201,.12)',
    icon: '0 3px 6px rgba(115,120,216,.15)',
    top: '5px -10px 20px rgba(91, 89, 193, 0.11)'
  }
};

var utils = {
  /**
   * Generates {n} to {n} classes for numerical Tailwind classes
   * Example: generate numbers 0 - 100 incremented by 5
   * generateRangeClasses(0, 100, 5, true) => {0: '0px', 5: '5px', 10: '10px', ... 100: '100px'}
   * @param {number} start - start count ex: 0
   * @param {number} stop - finish count ex: 100
   * @param {number} step - number to increment by
   * @param {boolean} [includeNegative=false] - include negative ex: generating margins
   * @returns
   */
  generateRangeClasses(start, stop, step) {
    let includeNegative = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const rangeArray = Array.from({
      length: (stop - start) / step + 1
    }, (_, i) => {
      return start + i * step;
    });
    return rangeArray.reduce((obj, value) => {
      obj[value] = `${value}px`;
      if (includeNegative) {
        obj[-value] = `-${value}px`;
      }
      return obj;
    }, {});
  },
  /**
   * Re-usable fraction class object
   */
  fractionClasses: {
    '1/2': '50%',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/5': '20%',
    '2/5': '40%',
    '3/5': '60%',
    '4/5': '80%',
    '1/6': '16.666667%',
    '2/6': '33.333333%',
    '3/6': '50%',
    '4/6': '66.666667%',
    '5/6': '83.333333%',
    '1/12': '8.333333%',
    '2/12': '16.666667%',
    '3/12': '25%',
    '4/12': '33.333333%',
    '5/12': '41.666667%',
    '6/12': '50%',
    '7/12': '58.333333%',
    '8/12': '66.666667%',
    '9/12': '75%',
    '10/12': '83.333333%',
    '11/12': '91.666667%'
  }
};

const {
  generateRangeClasses: generateRangeClasses$2
} = utils;
var borders = {
  borderRadius: {
    none: '0',
    full: '9999px',
    ...generateRangeClasses$2(0, 15, 1),
    ...generateRangeClasses$2(10, 30, 5)
  },
  borderWidth: {
    DEFAULT: '1px',
    ...generateRangeClasses$2(0, 20, 1)
  }
};

const {
  generateRangeClasses: generateRangeClasses$1
} = utils;
var spacing = {
  padding: {
    ...generateRangeClasses$1(0, 20, 1),
    ...generateRangeClasses$1(20, 500, 5)
  },
  margin: {
    ...generateRangeClasses$1(0, 500, 5, true)
  }
};

var fonts = {
  // ---------------------------------------------------------------
  // Font Family Customization
  // ---------------------------------------------------------------

  fontFamily: {
    body: ['open-sans', 'Arial', 'sans-serif'],
    display: ['garamond-premier-pro-caption', 'Garamond', 'serif']
  },
  // ---------------------------------------------------------------
  // Font Size Customization
  // ---------------------------------------------------------------

  fontSize: {
    // [fontSize, lineHeight]
    xxs: ['10px', '20px'],
    xs: ['12px', '20px'],
    sm: ['13px', '23px'],
    md: ['14px', '23px'],
    base: ['16px', '24px'],
    lg: ['20px', '26px'],
    xl: ['24px', '32px'],
    '2xl': ['32px', '40px'],
    '3xl': ['40px', '48px'],
    '4xl': ['48px', '58px'],
    '5xl': ['60px', '68px'],
    '6xl': ['70px', '78px'],
    '7xl': ['80px', '88px']
  },
  // ---------------------------------------------------------------
  // Line Height Customization
  // ---------------------------------------------------------------

  lineHeight: {
    1: '20px',
    2: '23px',
    3: '24px',
    4: '32px',
    5: '40px',
    6: '48px',
    7: '58px',
    8: '68px',
    none: '1',
    tight: '1.10'
  }
};

const {
  generateRangeClasses,
  fractionClasses
} = utils;
var dimensions = {
  width: {
    // fractions
    ...fractionClasses,
    // pixels
    ...generateRangeClasses(0, 1000, 5),
    // w-{0-1000} increments of 5 ex: '.w-5', '.w-265', ..
    ...generateRangeClasses(1000, 1500, 10) // w-{1000-1500} increments of 10 ex: '.w-1210', '.w-1450', ..
  },

  minWidth: {
    // fractions
    ...fractionClasses,
    // pixels
    ...generateRangeClasses(0, 1000, 5),
    // min-w-{0-1000} increments of 5 ex: '.min-w-5', '.min-w-205', ..
    ...generateRangeClasses(1000, 1500, 10) // min-w-{1000-1500} increments of 10 ex: '.min-w-10', '.min-w-1000', ..
  },

  maxWidth: {
    // fractions
    ...fractionClasses,
    // pixels
    ...generateRangeClasses(0, 1000, 5),
    // max-w-{0-1000} increments of 5 ex: '.w-5', '.w-205', ..
    ...generateRangeClasses(1000, 1500, 10) // max-w-{1000-1500} increments of 10 ex: '.w-10', '.w-1000', ..
  },

  height: {
    // fractions
    ...fractionClasses,
    // pixels
    ...generateRangeClasses(0, 1000, 5),
    // h-{0-1000} increments of 5 ex: '.h-5', '.h-205', ..
    ...generateRangeClasses(1000, 1500, 10) // h-{1000-1500} increments of 10 ex: '.h-10', '.h-1000', ..
  },

  minHeight: {
    // fractions
    ...fractionClasses,
    // pixels
    ...generateRangeClasses(0, 1000, 5),
    // h-{0-1000} increments of 5 ex: '.h-5', '.h-205', ..
    ...generateRangeClasses(1000, 1500, 10) // h-{1000-1500} increments of 10 ex: '.h-10', '.h-1000', ..
  },

  maxHeight: {
    // fractions
    ...fractionClasses,
    // pixels
    ...generateRangeClasses(0, 1000, 5),
    // max-h-{0-1000} increments of 5 ex: '.h-5', '.h-205', ..
    ...generateRangeClasses(1000, 1500, 10) // max-h-{1000-1500} increments of 10 ex: '.h-10', '.h-1000', ..
  }
};

var safelist$1 = [
	"bg-purple-50",
	"bg-blue-50",
	"bg-green-50",
	"bg-pink-50",
	"bg-yellow-50",
	"bg-purple-500",
	"bg-green-500",
	"bg-pink-500",
	"bg-blue-500",
	"bg-yellow-500",
	"bg-purple-400",
	"bg-green-400",
	"bg-pink-400",
	"bg-blue-400",
	"bg-yellow-400",
	"bg-purple-300",
	"bg-green-300",
	"bg-pink-300",
	"bg-blue-300",
	"bg-yellow-300",
	"bg-purple-200",
	"bg-green-200",
	"bg-pink-200",
	"bg-blue-200",
	"bg-yellow-200",
	"bg-purple-100",
	"bg-green-100",
	"bg-pink-100",
	"bg-blue-100",
	"bg-yellow-100",
	"border-purple-500",
	"border-green-500",
	"border-pink-500",
	"border-blue-500",
	"border-yellow-500",
	"border-purple-400",
	"border-green-400",
	"border-pink-400",
	"border-blue-400",
	"border-yellow-400",
	"border-purple-300",
	"border-green-300",
	"border-pink-300",
	"border-blue-300",
	"border-yellow-300",
	"border-purple-200",
	"border-green-200",
	"border-pink-200",
	"border-blue-200",
	"border-yellow-200",
	"border-purple-100",
	"border-green-100",
	"border-pink-100",
	"border-blue-100",
	"border-yellow-100",
	"text-purple-500",
	"text-green-500",
	"text-pink-500",
	"text-blue-500",
	"text-yellow-500",
	"text-purple-400",
	"text-green-400",
	"text-pink-400",
	"text-blue-400",
	"text-yellow-400",
	"text-purple-300",
	"text-green-300",
	"text-pink-300",
	"text-blue-300",
	"text-yellow-300",
	"text-purple-200",
	"text-green-200",
	"text-pink-200",
	"text-blue-200",
	"text-yellow-200",
	"text-purple-100",
	"text-green-100",
	"text-pink-100",
	"text-blue-100",
	"text-yellow-100",
	"caret-purple-400",
	"caret-green-400",
	"caret-pink-400",
	"caret-blue-400",
	"caret-yellow-400",
	"hover:bg-purple-500",
	"hover:bg-green-500",
	"hover:bg-pink-500",
	"hover:bg-blue-500",
	"hover:bg-yellow-500",
	"hover:bg-purple-400",
	"hover:bg-green-400",
	"hover:bg-pink-400",
	"hover:bg-blue-400",
	"hover:bg-yellow-400",
	"hover:bg-purple-300",
	"hover:bg-green-300",
	"hover:bg-pink-300",
	"hover:bg-blue-300",
	"hover:bg-yellow-300",
	"hover:bg-purple-200",
	"hover:bg-green-200",
	"hover:bg-pink-200",
	"hover:bg-blue-200",
	"hover:bg-yellow-200",
	"hover:bg-purple-100",
	"hover:bg-green-100",
	"hover:bg-pink-100",
	"hover:bg-blue-100",
	"hover:bg-yellow-100",
	"hover:border-purple-500",
	"hover:border-green-500",
	"hover:border-pink-500",
	"hover:border-blue-500",
	"hover:border-yellow-500",
	"hover:border-purple-400",
	"hover:border-green-400",
	"hover:border-pink-400",
	"hover:border-blue-400",
	"hover:border-yellow-400",
	"hover:border-purple-300",
	"hover:border-green-300",
	"hover:border-pink-300",
	"hover:border-blue-300",
	"hover:border-yellow-300",
	"hover:border-purple-200",
	"hover:border-green-200",
	"hover:border-pink-200",
	"hover:border-blue-200",
	"hover:border-yellow-200",
	"hover:border-purple-100",
	"hover:border-green-100",
	"hover:border-pink-100",
	"hover:border-blue-100",
	"hover:border-yellow-100",
	"hover:text-purple-500",
	"hover:text-green-500",
	"hover:text-pink-500",
	"hover:text-blue-500",
	"hover:text-yellow-500",
	"hover:text-purple-400",
	"hover:text-green-400",
	"hover:text-pink-400",
	"hover:text-blue-400",
	"hover:text-yellow-400",
	"hover:text-purple-300",
	"hover:text-green-300",
	"hover:text-pink-300",
	"hover:text-blue-300",
	"hover:text-yellow-300",
	"hover:text-purple-200",
	"hover:text-green-200",
	"hover:text-pink-200",
	"hover:text-blue-200",
	"hover:text-yellow-200",
	"hover:text-purple-100",
	"hover:text-green-100",
	"hover:text-pink-100",
	"hover:text-blue-100",
	"hover:text-yellow-100",
	"focus:bg-purple-400",
	"focus:bg-green-400",
	"focus:bg-pink-400",
	"focus:bg-blue-400",
	"focus:bg-yellow-400",
	"focus:border-purple-400",
	"focus:border-green-400",
	"focus:border-pink-400",
	"focus:border-blue-400",
	"focus:border-yellow-400"
];
var require$$7 = {
	safelist: safelist$1
};

const {
  colors
} = colors$1;
const {
  screens
} = screens$1;
const {
  boxShadow
} = shadows;
const {
  borderRadius,
  borderWidth
} = borders;
const {
  padding,
  margin
} = spacing;
const {
  fontSize,
  lineHeight,
  fontFamily
} = fonts;
const {
  width,
  minWidth,
  maxWidth,
  height,
  minHeight,
  maxHeight
} = dimensions;
const {
  safelist
} = require$$7;

/*
** Docs: https://tailwindcss.com/docs/configuration
** Default: https://github.com/tailwindcss/tailwindcss/blob/master/stubs/defaultConfig.stub.js
*/
var tailwind_config = {
  mode: 'jit',
  purge: {
    content: ['./public/index.html', './src/**/*.{js,jsx,vue}'],
    safelist
  },
  theme: {
    /*
      '{breakpoint}:{classes}'
      example usage with margins:
      '.xs-only:m-40' -- add 40px margin only on devices below 'sm' class
      '.md:m-60' -- add 60px margin between 'md' and 'lg' breakpoint
      '.lg:m-80' -- add 80px margin 'lg' and up
    */
    screens,
    /*
      '.{class}-{color}-{class}'
      example usage:
      '.bg-green-400'
      '.text-peach-300'
    */
    colors,
    /*
      '.text-{class}'
      example usage:
      '.text-sm'
      '.text-lg'
    */
    fontSize,
    /*
      '.leading-{class}'
      example usage:
      '.leading-1'
      '.leading-2'
    */
    lineHeight,
    /*
      '.shadow-{class?}'
      example usage:
      '.shadow'
      '.shadow-none'
      '.shadow-btn'
    */
    boxShadow,
    /*
      '.rounded-{size?}'
      example usage:
      '.rounded'
      '.rounded-none'
      '.rounded-full'
    */
    borderRadius,
    borderWidth,
    /*
      '.font-{class}'
      example usage:
      '.font-display' -> Sofia Pro
      '.font-body' -> Open Sans
    */
    fontFamily,
    /*
      Preserves default values for a theme option but also extends with new values
      https://tailwindcss.com/docs/theme/#extending-the-default-theme
    */
    extend: {
      /*
        '.w-{size}'
        example usage:
        '.w-500' -> width 500px
        '.w-1/4' -> width 25%
        '.md:w-3/4' -> width 75% on 'md' -> 'lg' breakpoints
      */
      width,
      /*
        '.max-w-{size}'
        example usage:
        '.max-w-500' -> max width 500px
        '.max-w-1/4' -> max width 25%
        '.md:max-w-3/4' -> max width 75% on 'md' -> 'lg' breakpoints
      */
      maxWidth,
      /*
        '.h-{size}'
        example usage:
        '.h-500' -> height 500px
        '.h-1/4' -> height 25%
        '.md:h-3/4' -> height 75% on 'md' -> 'lg' breakpoints
      */
      height,
      /*
        '.max-h-{size}'
        example usage:
        '.max-h-500' -> max height 500px
        '.max-h-1/4' -> max height 25%
        '.md:max-h-3/4' -> max height 75% on 'md' -> 'lg' breakpoints
      */
      maxHeight,
      /*
        '.min-h-{size}'
        example usage:
        '.min-h-500' -> min height 500px
        '.min-h-1/4' -> min height 25%
        '.md:min-h-3/4' -> min height 75% on 'md' -> 'lg' breakpoints
      */
      minHeight,
      /*
        '.min-w-{size}'
        example usage:
        '.min-w-500' -> min width 500px
        '.min-w-1/4' -> min width 25%
        '.md:min-w-3/4' -> min width 75% on 'md' -> 'lg' breakpoints
      */
      minWidth,
      /*
        '.m{side?}-{pixels||auto}'
        example usage:
        '.m-40' -> margin 40px on all sides
        '.-m-40' -> negative 40px margin on all sides
        '.mx-auto', -> margin auto only on x axis (left/right)
        '.md:mt-100' -> margin top 100px only on medium -> lg screens
      */
      margin,
      /*
        '.p{side?}-{pixels}'
        example usage:
        '.p-40' -> margin 40px on all sides
        '.md:pt-100' -> margin top 100px only on medium -> lg screens
      */
      padding,
      /*
        '.z-{index}'
        example usage:
        '.z-0' -> z-index: 0
      */
      zIndex: {
        1: '1',
        0: '0',
        n1: '-1',
        n2: '-2',
        max: '999999',
        '-max': '-999999'
      }
    }
  },
  corePlugins: {
    container: false
  },
  /*
    Add custom CSS classes inside newUtilities object below
  */
  plugins: [function (_ref) {
    let {
      addUtilities,
      addComponents
    } = _ref;
    const newUtilities = {
      '.rotate-90deg': {
        transform: 'rotate(90deg)'
      },
      '.skew-10deg': {
        transform: 'skewY(-10deg)'
      },
      '.skew-15deg': {
        transform: 'skewY(-15deg)'
      }
    };
    const newComponents = {
      '.container': {
        '@apply mx-auto px-30 sm:px-80 lg:px-40 md:max-w-1280': {}
      }
    };
    addUtilities(newUtilities);
    addComponents(newComponents);
  }

  // require('@tailwindcss/line-clamp')
  ]
};

const install = instance => {
  for (const componentKey in components) {
    instance.use(components[componentKey]);
  }
};

export { install as default, tailwind_config as tailwindConfig };
